"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRetention = exports.getNewFontNameForClass = exports.getFontNameForClass = void 0;
const getFontNameForClass = (name) => name === null || name === void 0 ? void 0 : name.replace(/[, \W]/g, "-");
exports.getFontNameForClass = getFontNameForClass;
// we have 2 font names for the same font, one with '-' and one without spaces,
// in order to support font names from the configuration in postgres that were saved before the Rich Text Feature release
const getNewFontNameForClass = (name) => name === null || name === void 0 ? void 0 : name.replace(/[, \W]/g, "");
exports.getNewFontNameForClass = getNewFontNameForClass;
var PageRetention;
(function (PageRetention) {
    PageRetention[PageRetention["WEEK"] = 7] = "WEEK";
    PageRetention[PageRetention["MONTH"] = 30] = "MONTH";
    PageRetention[PageRetention["YEAR"] = 365] = "YEAR";
})(PageRetention || (exports.PageRetention = PageRetention = {}));
//# sourceMappingURL=common.js.map